import React from 'react';

export const WidthClearance = ({ width, setWidth }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-medium text-gray-300">Width Clearance</h3>
      <div className="grid grid-cols-1 gap-4">
        <div>
          <label className="block text-gray-400 mb-2">Feet & Inches</label>
          <div className="grid grid-cols-2 gap-4">
            <input
              type="number"
              value={width.feet}
              onChange={(e) => setWidth(prev => ({
                ...prev,
                feet: e.target.value
              }))}
              className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
              min="0"
              placeholder="Feet"
            />
            <input
              type="number"
              value={width.inches}
              onChange={(e) => setWidth(prev => ({
                ...prev,
                inches: e.target.value
              }))}
              className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
              min="0"
              max="11"
              placeholder="Inches"
            />
          </div>
        </div>
        <div>
          <label className="block text-gray-400 mb-2">Or Meters</label>
          <input
            type="number"
            value={width.meters}
            onChange={(e) => setWidth(prev => ({
              ...prev,
              meters: e.target.value
            }))}
            className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
            min="0"
            step="0.01"
            placeholder="Enter width in meters"
          />
        </div>
      </div>
    </div>
  );
};

export default WidthClearance;